import type { Discovery$Control, Discovery$Video } from '#~/device/discovery/index.js';
import type { Props as DialogProps } from '@studio/design-system/dialog';
import type { Credentials as M_Credentials } from '@studio/models/auth';

/** Aggregated discovery type. */
export type Discovery = Discovery$Control | Discovery$Video;

/** Video device filter. */
export enum Filter {
  All = 'a',
  NDI = 'n',
  ONVIF = 'o',
  IRIS = 'i',
  // Plain RTSP (VideoProtocol.RTSP/RTSPT/RTSPLT) is a video discovery —
  // distinct from ONVIF which is a control-plane protocol, not a video one.
  RTSP = 'r'
  // SRT = 's'
}

/** `<AddSourceAuth>` properties. */
export type Props = Omit<Omit<DialogProps, 'onBeforeClose' | 'open'>, 'children'> & {
  onConfirm: (credentials: M_Credentials) => void;
  onDismiss: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  error?: string | null;
  connecting?: string | null;
  /** True while this attempt's details→cloud-link promise has not settled. */
  rawPending?: boolean;
  lockoutStatus?: {
    isLocked: boolean;
    unlockTimeSeconds: number;
  } | null;
  onLockoutChange?: (status: { isLocked: boolean; unlockTimeSeconds: number } | null) => void;
};
